/**
 * Comptage des offres eligibles et decision de masquage du listing order page.
 * Masquer des qu'il y a exactement 1 offre eligible : il n'y a alors plus de
 * choix alternatif a presenter. L'eventuel quick-sell de cette offre est
 * surface dans l'order-summary (cf. OrderSummary.vue / hasNoAlternativeChoice).
 */
export default class OrderPageOffers {
  static isChoiceVisible(choice) {
    return choice && choice.show !== false && choice.show != 0;
  }

  static getEligibleOffers(
    products,
    { getDefaultChoice, isChoiceDisabled } = {},
  ) {
    if (!Array.isArray(products)) {
      return [];
    }

    return products.filter((product) => {
      const choice = getDefaultChoice
        ? getDefaultChoice(product)
        : product?.choice;
      if (!this.isChoiceVisible(choice)) {
        return false;
      }
      if (isChoiceDisabled?.(product)) {
        return false;
      }
      return true;
    });
  }

  static isOfferChoice(choiceId, productDetails) {
    const initialChoices = productDetails?.initialChoices;
    if (!Array.isArray(initialChoices)) {
      return false;
    }
    const id = String(choiceId);
    return initialChoices.some(
      (group) =>
        Array.isArray(group) &&
        group.some((choice) => String(choice?.id) === id),
    );
  }

  /**
   * Groupe quick-sell applicable a une offre : celui rattache a l'offre en
   * priorite, sinon le groupe de la page (scope "page", sans parentId). Le
   * groupe de la page ne s'applique qu'aux offres de la page (pas aux
   * cross-sells) et seulement s'il propose un choice autre que l'offre.
   */
  static findQuicksellEntry(parentChoiceId, productDetails) {
    const upsells = productDetails?.upsells;
    if (
      parentChoiceId == null ||
      parentChoiceId === "" ||
      !Array.isArray(upsells)
    ) {
      return null;
    }

    const id = String(parentChoiceId);
    const offerEntry = upsells.find(
      (entry) =>
        entry?.scope !== "page" &&
        entry?.parentId != null &&
        String(entry.parentId) === id,
    );
    if (offerEntry) {
      return offerEntry;
    }

    if (!this.isOfferChoice(id, productDetails)) {
      return null;
    }
    const pageEntry = upsells.find((entry) => entry?.scope === "page");
    const offersOtherChoice = (pageEntry?.children || []).some(
      (group) =>
        Array.isArray(group) &&
        group.some((choice) => String(choice?.id) !== id),
    );
    return offersOtherChoice ? pageEntry : null;
  }

  static hasQuickSellForChoice(choiceId, productDetails) {
    return !!this.findQuicksellEntry(choiceId, productDetails);
  }

  static shouldHideOfferListing(products, productDetails, options = {}) {
    const eligible = this.getEligibleOffers(products, options);
    return eligible.length === 1;
  }

  /**
   * Vrai quand aucun choix alternatif n'est possible sur la page : soit un
   * seul choix configure (un unique groupe dans initialChoices), soit un choix
   * force via le parametre hideListing. Dans ce cas, le quick-sell eventuel est
   * presente dans l'order-summary plutot que dans la liste d'offres.
   */
  static hasNoAlternativeChoice({ productDetails, hideListing = false } = {}) {
    if (hideListing) {
      return true;
    }
    const initialChoices = productDetails?.initialChoices;
    return Array.isArray(initialChoices) && initialChoices.length === 1;
  }
}
